import React, { useState } from 'react';
import { Container, Button, Row, Col, Image, Card, Alert } from 'react-bootstrap';

export default function Donate() {
  const [showQR, setShowQR] = useState(false);

  const handleGiveNow = (e) => {
    e.preventDefault();
    setShowQR(true);
  };

  const handleBack = (e) => {
    e.preventDefault();
    setShowQR(false);
  };

  return (
    <Container className="px-1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div style={{ color: '#1a3a44', borderRadius: '0', padding: '1.5rem 2rem 2rem', zIndex: 3, fontFamily: "'Nyoetes', 'Sora', 'Space Grotesk', 'Poppins', 'Segoe UI', sans-serif" }}>
        <div className="text-center mb-4">
          <h2 className="fw-bold mb-3" style={{ fontSize: '3.425rem', color: '#c53607f5' }}>Give</h2>
          <p className="fs-5" style={{ color: '#1a3a44' }}>Your financial gifts support ministry, outreach, and community programs.</p>
        </div>
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8}>
            <Card className="h-100" style={{ background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)', display: 'flex', flexDirection: 'column', border: '4px solid rgba(255,255,255,0.2)', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
              <Card.Body className="p-3 p-md-4">
                <Alert className="border-start border-4 mb-4" style={{ background: '#e8f5e9', borderLeftColor: '#198754' }}>
                  {/* <Alert.Heading className="fw-bold mb-2" style={{ color: '#1a3a44' }}></Alert.Heading> */}
                  <p className="mb-0 text-secondary" style={{ fontSize: '1.1rem' }}>Click the button below to view the QR code for secure giving.</p>
                </Alert>

                {!showQR ? (
                  <div>
                    <Button
                      href="#"
                      onClick={handleGiveNow}
                      size="lg"
                      className="w-100 fw-bold"
                      style={{ background: 'linear-gradient(180deg, rgba(250, 163, 150, 0.95), #c53607f5)', border: 'none' }}
                    >
                      💳 Give Now
                    </Button>
                  </div>
                ) : (
                  <div className="d-flex flex-column align-items-center text-center">
                    <p className="text-muted mb-4" style={{ fontSize: '1.1rem' }}>Scan the QR code below with your phone to give securely</p>
                    <div className="mb-4">
                      <Image src="/churchQR.jpeg" alt="Church QR Code" className="d-block mx-auto" style={{ maxWidth: '250px', borderRadius: '8px', border: '3px solid #e8943a' }} />
                    </div>
                    <Button
                      href="#"
                      onClick={handleBack}
                      size="lg"
                      variant="outline-secondary"
                      className="w-100"
                    >
                      ← Go Back
                    </Button>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
